module.exports = __webpack_public_path__ + "static/68-c53cb65ef07ab64aaeddcef50b534b12.png";